import { render, staticRenderFns } from "./ViAdmissionImpexp.vue?vue&type=template&id=aeaa5ffe"
import script from "./ViAdmissionImpexp.vue?vue&type=script&lang=js"
export * from "./ViAdmissionImpexp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports